import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import moment from 'moment'
import { DownloadXlsxInput } from '../domain/dtos/download-xlsx-input'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'
import { GetOfferIds } from './get-offer-ids'

export class DownloadXlsx {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: DownloadXlsxInput): Promise<void> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.BFF_WEB_URL}/subscriptions/export`,
      responseType: 'arraybuffer',
      body: this.makeBody(input),
    })

    if (response.statusCode === HttpStatusCode.CREATED) {
      return this.makeOutput(response.data)
    }

    throw new GeneralError()
  }

  private makeOutput(value: ArrayBuffer) {
    // Create a Blob from the ArrayBuffer
    const blob = new Blob([new Uint8Array(value)], { type: 'text/csv;charset=utf-8;' })

    // Create a URL for the Blob
    const blobURL = URL.createObjectURL(blob)

    // Create a download link
    const link = document.createElement('a')
    link.href = blobURL
    link.download = `export-subscriptions-${moment().format('YYYY-MM-DDT_HH-mm-ss')}.xlsx` // The desired filename

    // Trigger a click event to initiate the download
    link.click()

    // Clean up the Blob URL
    URL.revokeObjectURL(blobURL)
  }

  private makeBody(input: DownloadXlsxInput) {
    const offerIds = new GetOfferIds().execute({ offerIds: input.offerIds, offers: input.offers })

    return {
      offerIds,
      timezone: moment().format('Z'),
      filters: {
        status: input.statuses,
        planType: input.planType,
        startDate: input.startDate,
        endDate: input.endDate,
        dateRangeBy: input.dateRangeBy,
      },
    }
  }
}
